import GlobalStyles from '@mui/material/GlobalStyles';

const globalStyles = (
  <GlobalStyles
    styles={{
      ':root': {
        '--fluid-font-size': 'calc(0.5em + (2vw / 3))',
        fontSize: 'max(1em, var(--fluid-font-size))',
      },
    }}
  />
);

export default globalStyles;
